export default __webpack_public_path__ + "static/media/linkedin.712c452d.png";